import { render } from "./AboutImage.vue?vue&type=template&id=0096f62c&scoped=true"
import script from "./AboutImage.vue?vue&type=script&lang=js"
export * from "./AboutImage.vue?vue&type=script&lang=js"

import "./AboutImage.vue?vue&type=style&index=0&id=0096f62c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0096f62c"]])

export default __exports__